export interface AssignorStakeHolder  {
  nome: string;
  tipoPessoa: string;
  cpfCnpj: string;
}
